<div class="ibe-loader-pusher" *ngIf="(isLoading)"></div>
<div class="ibe-loader-bar" *ngIf="(isLoading)"></div>
